// File size limits in bytes
export const FILE_SIZE_LIMITS = {
  IMAGE: 10 * 1024 * 1024, // 10MB for images
  PDF: 25 * 1024 * 1024, // 25MB for PDFs
  VIDEO: 100 * 1024 * 1024, // 100MB for videos
};

// Helper to format file size for error messages
export const formatFileSize = (bytes: number): string => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};

// Validate file size based on file type
export const validateFileSize = (
  file: File
): { valid: boolean; error?: string } => {
  const isImage =
    file.type.startsWith('image/') && file.type !== 'application/pdf';
  const isPDF = file.type === 'application/pdf';
  const isVideo = file.type.startsWith('video/');

  let limit: number;
  let limitLabel: string;

  if (isImage) {
    limit = FILE_SIZE_LIMITS.IMAGE;
    limitLabel = '10MB';
  } else if (isPDF) {
    limit = FILE_SIZE_LIMITS.PDF;
    limitLabel = '25MB';
  } else if (isVideo) {
    limit = FILE_SIZE_LIMITS.VIDEO;
    limitLabel = '100MB';
  } else {
    return { valid: true };
  }

  if (file.size > limit) {
    return {
      valid: false,
      error: `"${file.name}" is too large (${formatFileSize(file.size)}). Maximum size for this file type is ${limitLabel}.`,
    };
  }

  return { valid: true };
};

export const isSupportedCompanyAboutFileHelper = (file: File): boolean => {
  return (
    file.type.startsWith('image/jpeg') ||
    file.type.startsWith('image/png') ||
    file.type.startsWith('image/jpg') ||
    file.type.startsWith('image/webp') ||
    file.type === 'application/pdf'
  );
};
export const isSupportedIdConfirmationFileHelper = (file: File): boolean => {
  return (
    file.type.startsWith('image/jpeg') ||
    file.type.startsWith('image/png') ||
    file.type.startsWith('image/jpg') ||
    file.type.startsWith('image/webp')
  );
};

export const isSupportedCompanyRegistrationFileHelper = (
  file: File
): boolean => {
  return (
    file.type.startsWith('image/jpeg') ||
    file.type.startsWith('image/png') ||
    file.type.startsWith('image/jpg') ||
    file.type.startsWith('image/webp') ||
    file.type === 'application/pdf'
  );
};

export const isSupportedIdConfirmationVideoFileHelper = (
  file: File
): boolean => {
  return file.type.startsWith('video/');
};

export const isSupportedSportBackgroundFileHelper = (file: File): boolean => {
  return (
    file.type.startsWith('image/jpeg') ||
    file.type.startsWith('image/png') ||
    file.type.startsWith('image/jpg') ||
    file.type.startsWith('image/webp') ||
    file.type === 'application/pdf' ||
    file.type.startsWith('video/mp4') ||
    file.type.startsWith('video/avi')
  );
};
